module.exports = __webpack_public_path__ + "media/images/payment-sbp-eb7bc067b414bf81b76a43c59e385364.png";